import {apiUrl} from '../constants';
import axios from 'axios';

var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':'Bearer ' +localStorage.getItem('token'),'Content-Type':'application/json'}
})

export default class SustitutosInsumosAPI {

    static GetDrives = () => {
        return request.get('SustitutosInsumos/GetDrives')
    }

    static GetSustitutos = (idCaffenio) => {
        return request.get(`SustitutosInsumos/GetSustitutos/${idCaffenio}`)
    }

    static CreateSustitutos = (listaSustitutosInsumos) => {
        return request.post(`SustitutosInsumos/`, listaSustitutosInsumos);
    }

    static DeleteSustituto = (sustituto) => {
        return request.delete(`SustitutosInsumos/DeleteSustituto/`, {data: sustituto})
    }
    
}